export default __webpack_public_path__ + "static/x-series-24-smokeless-fire-pit-e2a8fee302b5d5a06c09842ff018bb6d.jpg";